export default __webpack_public_path__ + "58f0dd01e76b3bac1e5916101af62cfe.svg";